import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './general.css';

function GeneralContracting() {
  const images = [
    "/images/General Contracting/Gen Contracting_01.jpg",
    "/images/General Contracting/Gen Contracting_02.jpg",
    "/images/General Contracting/Gen Contracting_03.jpg",
    "/images/General Contracting/Gen Contracting_05.jpg",
    "/images/General Contracting/Gen Contracting_07.jpg",
    "/images/General Contracting/Gen Contracting_09.jpg",
    "/images/General Contracting/Gen Contracting_10.jpg",
    "/images/General Contracting/Gen Contracting_11.jpg",
    "/images/General Contracting/Gen Contracting_12.jpg",
    "/images/General Contracting/Gen Contracting_13.jpg",
    "/images/General Contracting/Gen Contracting_14.jpg",
    "/images/General Contracting/Gen Contracting_15.jpg",
    "/images/General Contracting/Gen Contracting_16.jpg",
    "/images/General Contracting/Gen Contracting_17.jpg",
    "/images/General Contracting/Gen Contracting_18.jpg",
    "/images/General Contracting/Gen Contracting_19.jpg",
    "/images/General Contracting/Gen Contracting_20.jpg",
    "/images/General Contracting/Gen Contracting_21.jpg",
    "/images/General Contracting/Gen Contracting_22.jpg",
    "/images/General Contracting/Gen Contracting_23.jpg",
    "/images/General Contracting/Gen Contracting_24.jpg",
    "/images/General Contracting/Gen Contracting_25.jpg",
    "/images/General Contracting/Gen Contracting_26.jpg"
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [loaded, setLoaded] = useState(false);

  // Preload images
  useEffect(() => {
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, [images]);

  const nextImage = () => {
    setLoaded(false); // Start fade out
    setTimeout(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      setLoaded(true); // Fade in new image
    }, 300); // Fade duration
  };

  const prevImage = () => {
    setLoaded(false);
    setTimeout(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
      setLoaded(true);
    }, 300);
  };

  // Auto change image every 6 seconds
  useEffect(() => {
    setLoaded(true);
    const interval = setInterval(nextImage, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="generalcontracting-container">
      <Link to="/" className="home-button">Home</Link>
      <div className="text-container">
        <h3 className="title-gc">General Contracting</h3>
        <p className="text-blurb">
          Our general contracting services include comprehensive management of construction projects, 
          from initial design and planning through to final execution. We specialize in residential and 
          commercial renovations, ensuring quality workmanship and attention to detail.
        </p>
      </div>

      <div className="image-frame">
        <div className="slideshow-container">
          <img
            src={images[currentImageIndex]}
            alt="General Contracting"
            className={`generalcontracting-image ${loaded ? 'loaded' : 'loading'}`}
          />
          
          <button className="prev-button" onClick={prevImage}>❮</button>
          <button className="next-button" onClick={nextImage}>❯</button>
        </div>
      </div>
    </div>
  );
}

export default GeneralContracting;
